import {
  focusBlockEnd,
  getSelectedModelsCommand,
} from '@blocksuite/affine-shared/commands';
import { isInsideBlockByFlavour } from '@blocksuite/affine-shared/utils';
import {
  type SlashMenuActionItem,
  type SlashMenuConfig,
  type SlashMenuItem,
} from '@blocksuite/affine-widget-slash-menu';
import { LayoutIcon } from '@blocksuite/icons/lit';

import { insertColumnsBlockCommand } from '../commands/insert-columns.js';

const COLUMN_COUNTS = [2, 3, 4, 5] as const;

function createColumnsItem(
  columnCount: number,
  group: SlashMenuItem['group']
): SlashMenuActionItem {
  return {
    name: `${columnCount} columns`,
    group,
    description: 'Place blocks side by side.',
    icon: LayoutIcon(),
    searchAlias: ['column', 'columns', 'layout'],
    when: ({ model }) =>
      model.parent?.flavour === 'affine:note' &&
      !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
    action: ({ std }) => {
      std.command
        .chain()
        .pipe(getSelectedModelsCommand)
        .pipe(insertColumnsBlockCommand, {
          columnCount,
          place: 'after',
          removeEmptyLine: true,
        })
        .pipe(({ insertedColumnsBlockId }) => {
          if (!insertedColumnsBlockId) return;
          // The blocks exist in the store immediately but their components do
          // not, so the caret has to wait for the host to render.
          std.host.updateComplete
            .then(() => {
              const row = std.store.getModelById(insertedColumnsBlockId);
              const firstParagraphId = row?.children[0]?.children[0]?.id;
              if (!firstParagraphId) return;
              const focusBlock = std.view.getBlock(firstParagraphId);
              if (!focusBlock) return;
              std.command.exec(focusBlockEnd, { focusBlock });
            })
            .catch(console.error);
        })
        .run();
    },
  };
}

export const columnsSlashMenuConfig: SlashMenuConfig = {
  items: COLUMN_COUNTS.map((count, index) =>
    createColumnsItem(count, `4_Content & Media@${10 + index}`)
  ),
};
